export class ReportNameConstants {
    public static ViewIncentives = 'View Incentives';
    public static DownlineReport = 'Downline Report';
    public static DownlineMapReport = 'Downline Map Report';
    public static UplineReport = 'Upline Report';
    public static OrderHistory = 'Order History';
    public static MyVolume = 'My Volume';
    public static TotalCCVolumeTrend = 'Total CC Volume Trend';
    public static MyDownlineVolume = 'My Downline Volume';
    public static BonusRecapMyEarnings = 'Bonus Recap/ My Earnings';
    public static MyCustomers = 'My Customers';
    public static PersonallySponsoredFBOs = 'Personally Sponsored FBOs';
    public static YourBusiness = 'Your Business';
    public static NextLevelGoal = 'Next Level Goal';
    public static FourCCActive = '4CC Active';
    public static LeadershipBonus = 'Leadership Bonus';

    /* Incentives Report Constants */
    public static LEADERSHIP_BONUS = 'leadership';
    public static GEM_BONUS = 'gem';
    public static GLOBAL_RALLY = 'globalrally';
    public static EAGLE_MANAGER = 'eaglemanager';
    public static EAGLE_MANAGER_INCENTIVE = 'eagleManagerIncentive';
    public static CHAIRMANS_BONUS = 'chairman';
    public static EARNED_FOREVER = 'earned';
    public static CURRRENT_LEVEL = '20K';
    public static NOVEMBER = 'November';
    public static DECEMBER = 'December';

}



// WEBPACK FOOTER //
// ./src/app/customerservice/constants/report-names.constants.ts